import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'wz-rect-button',
  templateUrl: './rect-button.component.html',
  styleUrls: ['./rect-button.component.scss'],
  standalone: false,
})
export class RectButtonComponent implements OnInit {
  @Input() type = 'button';
  @Input() i18nKey!: string;
  @Input() disabled!: boolean;
  @Input() color: string = 'primary';
  @Input() isLoading!: boolean;
  @Input() raised: boolean = true;

  @Input() matIcon!: string;

  @HostBinding('class.has-icon') public hasIcon!: boolean;

  constructor() {}

  ngOnInit() {
    if (this.matIcon) {
      this.hasIcon = true;
    }
  }

  onClick(event: Event) {
    if (this.disabled || this.isLoading) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      return false;
    }

    return true;
  }
}
